module.exports = __webpack_public_path__ + "img/nearby-scene30.ed479aea.svg";